<template>
  <div>
    <!-- 账号密码登录 -->
    <el-form
      :model="inputTo"
      :rules="rules"
      class="pad-top20 width46 margin-auto"
    >
      <el-form-item
        prop="account"
        class="flex-input margin-auto buttom-none width100"
      >
        <el-input
          size="medium"
          type="text"
          class="el-input"
          v-model="inputTo.account"
          placeholder="账号"
          ><i slot="prefix" class="lineheight40 el-icon-s-custom"></i
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="password"
        class="flex-input margin-auto pad-top10 buttom-none width100"
      >
        <el-input
          size="medium"
          type="password"
          class="el-input"
          v-model="inputTo.password"
          show-password
          placeholder="密码"
          ><i slot="prefix" class="lineheight40 el-icon-lock"></i
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="width46 margin-auto">
      <button
        class="main-imgt textalign-center buttom-none color-fff cursorpointer"
        :style="{
          background:
            inputTo.password == ''
              ? '#e7e9ef'
              : '#52C6CC' && inputTo.account == ''
              ? '#e7e9ef'
              : '#52C6CC',
          color:
            inputTo.password == ''
              ? '#969EAC'
              : '#fff' && inputTo.account == ''
              ? '#969EAC'
              : '#fff',
        }"
        @click.prevent="toVerifica()"
      >
        登 录
      </button>
    </div>
    <p class="width46 margin-auto textalign-center f14 cursorpointer">
      <span>还没有账号？</span
      ><span @click="righten" style="color: #52c6cc">立即注册</span>
    </p>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { checkLogin } from "@/api/login/login.api";
// 外部mixin——主要负责表单校验
import formMixin from "./mixins/formMixin.js";
import VueCookie from "vue-cookie";
import BUS from "@/BUS/BUS";
export default {
  mixins: [formMixin],
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      inputTo: {
        account: "",
        password: "",
      },
    };
  },
  methods: {
    righten() {
      BUS.$emit("righten", 111);
    },
    // 登录
    toVerifica() {
      if (this.inputTo.account == "" || this.inputTo.password == "") {
        return;
      }
      // 登录
      else {
        checkLogin({
          username: this.inputTo.account,
          password: this.inputTo.password,
        }).then((res) => {
          if (res.data.code == 200 && res.data.msg == "登录成功") {
            // 保存token
            window.localStorage.setItem("token", res.data.data.token);
            window.sessionStorage.setItem("token", res.data.data.token);
            let token = res.data.data.token;
            VueCookie.set("token", token, 14 * 24 * 60 * 60);
            window.sessionStorage.setItem(
              "phon",
              this.inputTo.account || window.localStorage.getItem("username")
            );
            this.$router.push("/home");
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
  },
  components: {},

  created() {},
  mounted() {},
};
</script>

<style scoped>
.dialog-title >>> .el-dialog__header {
  padding: 20px 0 20px 0;
  background: #dfdfdf;
  border-bottom: 1px solid rgb(202, 200, 200);
}
.dialog-padding >>> .el-dialog--center .el-dialog__body {
  padding: 0px 25px 30px;
}
.seizeaseat {
  width: 100%;
  height: 186px;
}
.seizeaseats {
  width: 100%;
  height: 143px;
}
.mainBlue {
  color: #0039bf;
  line-height: 30px;
}
/* 切换按钮 */
.SignRegister {
  margin: 10% auto 0;
}
.sign-buttom {
  background: #dfdfdf;
  width: 100px;
  height: 35px;
  line-height: 40px;
}
.setClassName {
  color: white;
  background: #0039bf;
}
/* 切换内容 */
.loginBox {
  background: #0039bf;
  /* padding-top: 100px; */
}
/*账号密码登录 input */
.flex-input {
  height: 40px;
  color: #b7b7b7;
}
.el-input >>> .el-input__inner {
  border-radius: 4px;
  height: 40px;
  border: 1px solid #efefef;
  outline: none;
  background: #f6f7fb;
  /* line-height: 40px; */
  /* margin-bottom: 10px; */
}
.verification {
  height: 40px;
  background: #ffc721;
  padding-bottom: 1px;
}
/* 登录按钮 */
.main-imgt {
  width: 100%;
  margin: 20px auto 20px;
  height: 46px;
  background: #e7e9ef;
  border-radius: 23px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #969eac;
  text-align: center;
  line-height: 14px;
  font-weight: 500;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>